<template>
    <div class="modal-invoice">
        <SOSlotModal :modal-title="modalTitle" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div>
                    <div class="m-d-20">
                        <SOInformation :title="getInformationTitle" myStyle="margin: 0px -40px;">
                            <template v-slot:subtitle>
                                <p class="m-d-0">
                                    Selesaikan dan pengambilan transaksi sekaligus.
                                </p>
                            </template>
                        </SOInformation>
                    </div>
                    <p class="m-d-8 f-16 f-c-black f-regular">
                        Anda memilih transaksi yang belum selesai. Pembuatan invoice akan
                        <span class="f-bold">sekaligus memproses selesaikan & pengambilan transaksi.</span>
                    </p>
                </div>
            </template>
            <template v-slot:modal-footer>
                <div class="">
                    <SOButton
                        :outline="true"
                        :full="true"
                        :text="'Oke, Paham'"
                        :id="`confirm-add`"
                        @action="doConfirm"
                    />
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import resulter from "@/store/utils/resulter";

import SOInformation from "@/so-components/global/ui/SOInformation.vue";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import SOButton from "@/so-components/global/ui/SOButton";

import { moduleName } from "../../store/state";

export default {
    name: "ConfirmAddInvoice",
    components: {
        SOSlotModal,
        SOButton,
        SOInformation,
    },
    data() {
        return {
            modalId: "confirm-add-invoice",
            modalTitle: "Konfirmasi Selesaikan Transaksi",
            page: {
                loading: false,
            },
        };
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
    },
    computed: {
        ...mapGetters(moduleName, {
            isCheckAll: "isCheckAll",
            selectedTransaksi: "selectedTransaksi",
        }),
        isFetching() {
            return this.page.loading;
        },
        totalSelected() {
            return 4;
        },
        getInformationTitle() {
            return `Transaksi belum selesai: <span class="f-bold">${this.totalSelected} Transaksi</span>`;
        },
    },
    methods: {
        ...mapActions({
            setFetching: `${moduleName}/setFetching`,
            setResponse: `${moduleName}/setResponse`,
            updateStatus: `${moduleName}/updateStatus`,
            getDetailTinyDevice: `${moduleName}/getDetailTinyDevice`,
            getDetailStatusTn: `${moduleName}/getDetailStatusTn`,
            getListAktivitas: `${moduleName}/getListAktivitas`,
        }),
        async back(idx = -1) {
            await this.$router.go(idx);
        },

        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        doConfirm() {
            this.$router.push({ name: "invoice.create" });
        },
    },
};
</script>
